// extracted by mini-css-extract-plugin
export default {"container":"WithLoader_container__VdJoc","loader":"WithLoader_loader__zds1m","spin":"WithLoader_spin__D-KoR","loadingText":"WithLoader_loadingText__8+q1y"};